import Tippy from '@tippyjs/react';

import { NAME_MAX_LENGTH } from 'lib/constants/nameMaxLength';

import Icon from 'components/shared/Icon/Icon';
import Input from 'components/shared/Input/Input';
import { Alert } from 'components/shared/Alert/Alert';
import Checkbox from 'components/shared/Checkbox/Checkbox';
import Transition from 'components/shared/Transition/Transition';
import RadioButton from 'components/shared/RadioButton/RadioButton';

import { tagColorOptions } from '../../../lib/tagColorOptions';

const TagCreateFields = ({
  formik,
  selectedColor,
  onChange,
  onSelectColor,
  isPrivateBlocked = false,
  privateBlockReason
}) => (
  <>
    <div className="flex gap-4">
      <Input
        label="Name"
        className="max-w-[284px] grow"
        value={formik.values.name}
        name="name"
        id="name"
        data-qa="tag-name"
        onChange={(event) => onChange('name', event.target.value)}
        error={formik.errors.name}
        maxLength={NAME_MAX_LENGTH.tag}
      />
      <div className="flex flex-col gap-4">
        <span className="text-sm font-500 leading-[22px] text-neutral-800">Privacy</span>
        <div className="flex items-center gap-3">
          <RadioButton
            label="Public"
            name="public"
            data-qa="tag-radio-public"
            id="public"
            value={formik.values.isPublic}
            isSelected={formik.values.isPublic}
            onChange={() => onChange('isPublic', true)}
          />
          <Tippy
            content={privateBlockReason}
            className="tippy-dark"
            placement="top"
            disabled={!isPrivateBlocked}>
            <div>
              <RadioButton
                label="Private"
                name="private"
                id="private"
                data-qa="tag-radio-private"
                value={!formik.values.isPublic}
                isSelected={!formik.values.isPublic}
                disabled={isPrivateBlocked}
                onChange={() => onChange('isPublic', false)}
              />
            </div>
          </Tippy>
        </div>
      </div>
    </div>
    <div className="flex flex-col gap-2 !pb-1">
      <span className="text-sm font-500 leading-[22px] text-neutral-800">Color</span>
      <div className="flex max-w-[448px] flex-wrap gap-x-[14px] gap-y-3">
        {tagColorOptions.map((option, i) => (
          <button
            type="button"
            data-qa={`tag-color-${i}`}
            key={i}
            aria-label={option.name}
            aria-pressed={selectedColor === option.color}
            className="relative z-10 flex h-[24px] w-[24px] cursor-pointer items-center justify-center rounded-full p-0"
            style={{ backgroundColor: option.color, border: `1px solid ${option.border}` }}
            onClick={() => onSelectColor(option.color)}>
            <Transition isOpen={selectedColor === option.color} type="scale">
              <span className="block">
                <Icon icon="check-thick-linear" color="white" size={16} className="mt-[2px]" />
                <span
                  className="absolute left-[-3px] top-[-3px] -z-10 block h-[calc(100%+6px)] w-[calc(100%+6px)] rounded-full opacity-30"
                  style={{ backgroundColor: option.color }}
                />
              </span>
            </Transition>
          </button>
        ))}
      </div>
      {formik.errors.color && <p className="text-danger-500">{formik.errors.color}</p>}
    </div>
    <div className="flex flex-col gap-2 pb-1">
      <span className="text-sm font-500 leading-[22px] text-neutral-800">Importance</span>
      <div className="flex gap-2">
        <Checkbox
          label="Mark as important"
          isChecked={formik.values.isImportant}
          onChange={() => onChange('isImportant', !formik.values.isImportant)}></Checkbox>
        <Tippy
          content="Use this to communicate the urgency of this tag to your team."
          className="tippy-dark"
          placement="right">
          <div className="flex items-center ">
            <Icon icon="info-mono" />
          </div>
        </Tippy>
      </div>
    </div>
    <div className="overflow-hidden rounded-md border border-solid !border-primary-100">
      <Alert
        className="!w-full !border-0"
        icon="info-filled"
        iconShade={200}
        title={
          formik.values.isPublic === true
            ? 'Public tags can be viewed by anyone.'
            : 'Private tags are only viewable and editable by you.'
        }
      />
    </div>
  </>
);

export default TagCreateFields;
